export default __webpack_public_path__ + "static/media/varunada_lazurite_chunk.8e01d18b.png";